import React from "react";
import { Modal, Box, Typography, Button, Stack } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { useDispatch } from "react-redux";
import { setSelectedItems } from "../../redux/slices/contentSlice/contentForm/contentForm";
import { toast } from "react-toastify";
import { WATCH, LISTEN, DEVOTION, READ } from "../../constants";
import UploadSubtitleFile from "./UploadSubtitleFile";
import MasterFileUpload from "./MasterFileUpload";
import TrailerFileUpload from "./TrailerFIleUpload";
import VerticalPosterUpload from "./VerticalPosterUpload";
import HorizontalPosterUpload from "./HorizontalPosterUpload";
import BackgroundImageUpload from "./BackgroundImageUpload";
import ImagePreviews from "./ImagePreviews";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "80%",
	bgcolor: "background.paper",
	boxShadow: 24,
	maxWidth: "90%",
	minWidth: "60%",
	maxHeight: "90vh",
	overflowY: "auto",
	p: 4,
};

const UploadWatchContent = ({
	formik,
	masterFileContent,
	trailerContent,
	setMasterFileContent,
	setTrailerContent,
	setSelectedPosterFiles,
	setOpen,
	setIsLocalFilesUploaded,
}) => {
	const dispatch = useDispatch();
	const [posters, setPosters] = React.useState([]);
	const videoRef = React.useRef(null);
	const [subtitleFile, setSubtitleFile] = React.useState({
		file: "",
		filePath: "",
	});
	const [posterPreviews, setPosterPreviews] = React.useState([]);
	const [videoPreview, setVideoPreview] = React.useState("");
	const [pdfPreview, setPdfPreview] = React.useState("");
	const [audioPreview, setAudioPreview] = React.useState("");

	const [trailerView, setTrailerView] = React.useState("");
	const [fileType, setFileType] = React.useState("");

	const handlePosterFilesChange = (event) => {
		const file = event.target.files[0];
		console.log(file, "file");
		const guid = uuidv4();
		const type = formik.values.type;
		const category = formik.values.category;
		const title = formik.values.title;
		console.log(type, "type");
		const posterPath = `${type?.replace(/\s+/g, "")}/${category.replace(
			/\s+/g,
			""
		)}/${title.replace(/\s+/g, "")}/posters/${
			event.target.name
		}/${guid}.png`;
		if (!file) {
			return;
		}

		const posterPreview = {
			url: URL.createObjectURL(file),
			name: event.target.name,
		};

		setSelectedPosterFiles((prev) => [...prev, file]);
		setPosters((prevPoster) => [...prevPoster, posterPath]);
		setPosterPreviews((prevPrev) => [...prevPrev, posterPreview]);
	};

	const handleRemovePoster = (indexToRemove) => {
		setSelectedPosterFiles((currentFiles) =>
			currentFiles.filter((_, index) => index !== indexToRemove)
		);
		setPosters((currentPosters) =>
			currentPosters.filter((_, index) => index !== indexToRemove)
		);
		setPosterPreviews((currentPosters) =>
			currentPosters.filter((_, index) => index !== indexToRemove)
		);
	};

	const handleContentFileChange = (event) => {
		const file = event.target.files[0];
		const validTypes =
			formik.values.type === WATCH
				? [".mp4", ".mpeg"]
				: formik.values.type === LISTEN
				? [".mp3"]
				: formik.values.type === DEVOTION
				? [".mp4", ".mpeg", ".pdf", ".mp3"]
				: [".pdf"];

		const isValid = validTypes.some((type) => file.name.endsWith(type));

		if (!isValid) {
			toast.error("Invalid File Selected!");
			event.target.value = ""; // Clear the input
			return;
		}

		if (file) {
			if (event.target?.name === "trailer") {
				const fileName = event.target?.name;
				const { filePath, fileType } = handleFilePath(file, fileName);
				setTrailerContent({
					file,
					filePath,
				});
				setFileType(fileType);
			} else {
				const { filePath, fileType } = handleFilePath(file);
				setMasterFileContent({
					file,
					filePath,
				});
				setFileType(fileType);
			}
		}
	};

	const handleFilePath = (file, fileName) => {
		const fileExtension = file.name.split(".").pop().toLowerCase();
		let previewUrl = "";
		let fileType = "";
		const guid = uuidv4();

		if (["mp4", "webm", "ogg"].includes(fileExtension)) {
			previewUrl = URL.createObjectURL(file);
			fileType = "video";
			if (fileName && fileName === "trailer") {
				setTrailerView(previewUrl);
			} else {
				setVideoPreview(previewUrl);
			}
		} else if (["mp3", "wav", "ogg"].includes(fileExtension)) {
			previewUrl = URL.createObjectURL(file);
			fileType = "audio";
			setAudioPreview(previewUrl);
		} else if (["pdf"].includes(fileExtension)) {
			previewUrl = URL.createObjectURL(file);
			fileType = "pdf";
			setPdfPreview(previewUrl);
		}
		let filePath;
		const type = formik.values.type;
		const category = formik.values.category;
		const title = formik.values.title;

		if (fileName && fileName === "trailer") {
			filePath = `${type.replace(/\s+/g, "")}/${category.replace(
				/\s+/g,
				""
			)}/${title.replace(/\s+/g, "")}/trailer/${guid}.${fileExtension}`;
		} else {
			filePath = `${type.replace(/\s+/g, "")}/${category.replace(
				/\s+/g,
				""
			)}/${title.replace(/\s+/g, "")}/${guid}.${fileExtension}`;
		}

		return { filePath, fileType };
	};

	const handleRemoveContentFile = (e, type) => {
		if (type === "trailer") {
			setTrailerContent({
				file: "",
				filePath: "",
			});
			setTrailerView("");
		} else {
			setMasterFileContent({
				file: "",
				filePath: "",
			});
			setVideoPreview("");
		}
	};

	const saveChanges = () => {
		formik.setFieldValue("filePath", masterFileContent.filePath);
		formik.setFieldValue("trailerFilePath", trailerContent.filePath);
		formik.setFieldValue(
			"masterSubtitleFilePath",
			masterFileContent.subtitleFilePath
		);
		formik.setFieldValue(
			"trailerSubtitleFilePath",
			trailerContent.subtitleFilePath
		);
		formik.setFieldValue("posters", posters);

		dispatch(
			setSelectedItems([
				masterFileContent,
				trailerContent,
				...posterPreviews,
			])
		);
		setIsLocalFilesUploaded(true);
		setOpen(false);
	};

	React.useEffect(() => {
		return () => {
			if (videoPreview) {
				URL.revokeObjectURL(videoPreview);
			}
			if (trailerView) {
				URL.revokeObjectURL(trailerView);
			}

			if (audioPreview) {
				URL.revokeObjectURL(audioPreview);
			}
			if (pdfPreview) {
				URL.revokeObjectURL(pdfPreview);
			}
		};
	}, [videoPreview, trailerView, audioPreview, pdfPreview]);

	React.useEffect(() => {
		return () => {
			posterPreviews.forEach((preview) =>
				URL.revokeObjectURL(preview.url)
			);
		};
	}, [posterPreviews]);

	return (
		<Box sx={style}>
			<Typography
				textAlign={"center"}
				id="modal-modal-title"
				variant="h6"
				component="h2"
				marginBottom={4}
			>
				Upload Metadata
			</Typography>
			<Stack direction={"row"} justifyContent={"space-between"}>
				<Box sx={{ flexShrink: 0, flexGrow: 0, width: "45%" }}>
					<Stack direction={"row"} gap={2} alignItems={"end"}>
						<Box width={"50%"}>
							<MasterFileUpload
								fileType={fileType}
								videoPreview={videoPreview}
								pdfPreview={pdfPreview}
								audioPreview={audioPreview}
								handleRemoveContentFile={
									handleRemoveContentFile
								}
								handleContentFileChange={
									handleContentFileChange
								}
								formik={formik}
							/>
						</Box>
						<Box width={"50%"} flexGrow={0}>
							<UploadSubtitleFile
								formik={formik}
								subtitleFile={masterFileContent?.subtitleFile}
								setSubtitleFile={setMasterFileContent}
								name={"masterSubtitle"}
							/>
						</Box>
					</Stack>
					<Stack direction={"row"} gap={2} alignItems={"end"}>
						<Box width={"50%"} flexGrow={0}>
							<TrailerFileUpload
								fileType={fileType}
								trailerView={trailerView}
								handleRemoveContentFile={
									handleRemoveContentFile
								}
								handleContentFileChange={
									handleContentFileChange
								}
								formik={formik}
							/>
						</Box>
						<Box width={"50%"} flexGrow={0}>
							<UploadSubtitleFile
								formik={formik}
								subtitleFile={trailerContent?.subtitleFile}
								setSubtitleFile={setTrailerContent}
								name={"trailerSubtitle"}
							/>
						</Box>
					</Stack>
				</Box>
				<Box
					sx={{ flexShrink: 0, flexGrow: 0, width: "45%" }}
					flexShrink={0}
				>
					<VerticalPosterUpload
						posterPreviews={posterPreviews}
						handleRemovePoster={handleRemovePoster}
						handlePosterFilesChange={handlePosterFilesChange}
					/>
					<HorizontalPosterUpload
						posterPreviews={posterPreviews}
						handlePosterFilesChange={handlePosterFilesChange}
						formik={formik}
					/>
					<BackgroundImageUpload
						posterPreviews={posterPreviews}
						handlePosterFilesChange={handlePosterFilesChange}
						formik={formik}
					/>
					<ImagePreviews
						posterPreviews={posterPreviews}
						handleRemovePoster={handleRemovePoster}
					/>
				</Box>
			</Stack>
			<Button
				onClick={saveChanges}
				variant="outlined"
				fullWidth
				sx={{ marginTop: 5 }}
			>
				Save Changes
			</Button>
		</Box>
	);
};

export default UploadWatchContent;
